import { render, staticRenderFns } from "./LmAccessDeniedIcon.vue?vue&type=template&id=c3a4006e&"
import script from "./LmAccessDeniedIcon.vue?vue&type=script&lang=js&"
export * from "./LmAccessDeniedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports